import React, { useContext, useState } from 'react';

import { ActivateSubscriptionDialog } from '@vyce/core/src/components';
import { Invites } from '@vyce/core/src/modules';
import { listOfModules } from '@vyce/core/src/modules/invitesModule/config';
import {
  fetchInviteFilterInviters,
  fetchInviteFilterResources,
} from '@vyce/core/src/modules/invitesModule/utils';
import { usePermissions } from '@vyce/core/src/hooks/usePermissions';
import { ChatUser, MANAGEMENT_PERMISSIONS } from '@vyce/core/src/types';

import { useTypedSelector, useInviteButton } from 'src/hooks';
import { UniversalInviteModule } from 'src/modules';
import { InvitesContext } from 'src/store/invites-context';

const PENDING_INVITE_STATUSES = ['pending', 'sent', 'not_sent'];
const TEAMS_MODULE_FILTER = [listOfModules.teams];

export const PendingInvitesModule: React.FC = () => {
  const { selectedCompany } = useTypedSelector(state => state.helper);
  const { uuid, first_name, last_name, email, phone, photo } = useTypedSelector(state => state.user);
  const { getInvites, resendInvite, deleteInvite, retryInviteItem } = useContext(InvitesContext);
  const { can } = usePermissions();
  // The staff list behind "Invited by" takes its own right — don't ask for a guaranteed 403
  const canListStaff = can(MANAGEMENT_PERMISSIONS.LIST_STAFF);

  const [invitesReloadKey, setInvitesReloadKey] = useState(0);

  const {
    isInviteFormOpen,
    subscribeLoading,
    isActivateSubscriptionDialogOpen,
    simpleSubscribe,
    setCloseInviteForm,
    handleInviteButtonClick,
    closeActivateSubscriptionDialog,
  } = useInviteButton();

  const chatUser: ChatUser = {
    uid: uuid ?? '',
    name: `${first_name ?? ''} ${last_name ?? ''}`.trim(),
    email,
    phone,
    avatarUrl: photo?.url,
  };

  return (
    <>
      <Invites
        selectedCompanyId={selectedCompany?.uuid}
        statuses={PENDING_INVITE_STATUSES}
        modules={TEAMS_MODULE_FILTER}
        chatUser={chatUser}
        handleInviteButtonClick={handleInviteButtonClick}
        deleteInviteRequest={deleteInvite}
        getInvitesRequest={getInvites}
        resendInviteRequest={resendInvite}
        retryInviteItemRequest={retryInviteItem}
        fetchFilterResources={fetchInviteFilterResources}
        fetchFilterInviters={canListStaff ? fetchInviteFilterInviters : undefined}
        reloadKey={invitesReloadKey}
      />
      <UniversalInviteModule
        isOpen={isInviteFormOpen}
        onClose={setCloseInviteForm}
        onSuccess={() => setInvitesReloadKey(value => value + 1)}
      />
      <ActivateSubscriptionDialog
        open={isActivateSubscriptionDialogOpen}
        onClose={closeActivateSubscriptionDialog}
        callback={simpleSubscribe}
        loading={subscribeLoading}
        wasSubscribed={selectedCompany?.subscribed_company}
      />
    </>
  );
};
